

















import { Vue, Component, Prop, Model } from 'vue-property-decorator';

import BaseModal from './BaseModal.vue';
import BaseButton from '@/components/buttons/BaseButton.vue';

@Component({
    components: {
        BaseModal,
        BaseButton,
    }
})
export default class ConfirmModal extends Vue {
    @Model('update:open' ,{ required: true }) readonly  open!: boolean
    @Prop({ default: ''}) title!: string

    get openWrapper() { 
        return this.open;
    }

    set openWrapper(open) {
        const event = open ? 'open' : 'close';

        this.$emit(event);
        this.$emit('update:open', open);
    }

    ok() {
        this.$emit('ok');
        this.closeModal();
    }

    closeModal() {
        this.openWrapper = false;
    }
}
